/* eslint-disable jsx-a11y/alt-text */
import * as React from "react";
import { Image } from "react-datocms";
import CopyButton from "../CopyButton";
import { SCOUT_API_BASE_URL, convertMarkdownToHTML } from "../helpers";
import { Badge, Card, Code, Flex } from "@radix-ui/themes";

export function APIEndpointDescription({ beta, path, usecase, pricing, description, image = null, realtime = null }) {
    const completePath = `${SCOUT_API_BASE_URL}${path && path.endsWith("/") ? path : (path + "/")}`;
    return <>
        {image ? <div className="image"><Image data={image}  usePlaceholder={false}/></div> : null}
        {path && <div className="endpoint">
            <Badge color="green">GET</Badge><Code color="gray"><span>{path && path.endsWith("/") ? path : path + "/"}</span></Code>
            <span className="copy-container">
                <CopyButton text={completePath} />
            </span>
        </div>}
        {usecase && usecase.length > 0
            ? <div className="endpoint-usecase" dangerouslySetInnerHTML={{ __html: convertMarkdownToHTML((usecase as any)) }} />
            : null}

        <Card size="2">
            <Flex p="3" gap="6">
                {/* {integration_stage_requirement && <div className="">
                    <div>
                        <h3>Requires:</h3>
                    </div>
                    <div>
                        <IntegrationStages integrationStage={integration_stage_requirement} />
                    </div>
                </div>} */}

                {pricing && pricing.length > 0
                    ? <div className="">
                        <div>
                            <h3>Costs:</h3>
                        </div>
                        <div className="small">{pricing}</div>
                    </div>
                    : null}

                <div className="">
                    <div>
                        <h3>Processing:</h3>
                    </div>
                    <div className="small">{realtime ? " Realtime" : " Batch"}</div>
                </div>
                {beta
                    ? <div className="">
                        <div>
                            <h3>Support:</h3>
                        </div>
                        <div className="small">{beta ? "beta" : ""}</div>
                    </div>
                    : null}
            </Flex>
        </Card>
        
        {(description !== "<article></article>") && <div className="endpoint-description">
            {description ? <div dangerouslySetInnerHTML={{ __html: description }} /> : null}
        </div>}
        <style jsx>
            {`
            .icon {
                color: var(--pink);
                cursor: help;
            }
            .beta::after {
                content: ' BETA';
                font-size: var(--font-size-0);
                vertical-align: top;
                color: var(--blue);
                margin-left: 2px;
            }
            .small {
                margin-top: 5px;
            }
            .info {
                padding: 1.5rem;
                border: 1px solid var(--code-border);
                margin-top: 2rem;
                border-radius: var(--border-radius);
                display: flex;
                flex-direction: column;
                gap: 1rem;
            }
            .grid {
                display: grid;
                grid-template-columns: repeat(4, minmax(0, 1fr));
                gap: 1rem;
            }
            .description {
                width: 100%;
            }
            .flex {
                flex-direction: column;
            }
            h4 {
                margin-top: 0;
            }
            .image {
                border: 1px solid var(--code-border);
                width: 90px;
                border-radius: var(--border-radius);
                overflow: hidden;
                position: absolute;
                right: 2rem;
                top: -1rem;
                z-index: 99;
            }
            @media screen and (max-width: 767px) {
                .image {
                    display: none;
                }
            }
            .badge {
                height: auto;
                line-height: 16px;
                text-align: center;
                text-transform: uppercase;
                background-color: rgb(220,252,231);
                color: rgb(22,163,74);
                margin-right: 5px;
                border-radius: 5px;
                font-size: var(--font-size-2);
                display: flex;
                align-items: center;
                padding-right: 5px;
                padding-left: 5px;
                padding-top: 3px;
                padding-bottom: 3px;
            }
            .endpoint {
                overflow-x: auto;
                overflow-y: hidden;
                display: flex;
                height: auto;
            }
            .endpoint-usecase  :global(article code) {
                background-color: var(--code-background);
            }
            .endpoint-usecase :global(article) {
                padding: 0;
            }
            .copy-container {
                vertical-align: middle;
            }
            .endpoint-pricing {
                border: 1px solid var(--pink-light);
                background-color: var(--pink-light);
                padding: var(--default-vertical-spacing);
                border-radius: var(--border-radius);
            }
            .endpoint-integration-support {
                border: 1px solid var(--gray-medium);
                background-color: var(--gray-light);
                padding: var(--default-vertical-spacing);
                border-radius: var(--border-radius);
                align-items:center;
                gap:0.5rem;
                width: 100%;
            }
            .endpoint-integration-support p {
                padding: 0;
            }
            .endpoint-description :global(article) {
                padding: 0;
            }
            .endpoint-supported-chains {
                margin-top: 1rem;
            }
            `}
        </style></>;
}

export function APIEndpointCard({ title, path, usecase }) {

    return <><h3>{title}</h3>
        <div className="endpoint">
            <span className="badge">GET</span><code><span>{path}/</span></code>
        </div>
        {usecase && <div className="endpoint-description">
            {usecase ? <p suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: usecase }} /> : null}
        </div>}
        <style jsx>{`            
            .badge {
                width: 40px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                text-transform: uppercase;
                background-color: rgb(220,252,231);
                color: rgb(22,163,74);
                margin-right: 5px;
                border-radius: 5px;
                font-size: var(--font-size-1);
                padding-right: 5px;
                padding-left: 5px;
                padding-top: 3px;
                padding-bottom: 3px;
            }
            .endpoint {
                margin-top: 1rem;
            }
            .endpoint-description {
                margin-top: 1rem;
            }
            .endpoint-description :global(article) {
                padding: 0;
            }
            `}
        </style></>;
}
